import type { IconProps } from '../types/IconProps.ts';
export const SlidersVertical: IconProps = {
    name: 'SlidersVertical',
    children: [
        `<path d="M5 3v7M5 14v7m0-7H3m2 0h2M12 8h2m-2 0h-2m2 0V3M12 12v9M19 3v9M19 16h2m-2 0h-2m2 0v5" />`,
    ]
};